/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'navigation.global-shortcuts.all-sites': 'Все сайты',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': 'Аналитика',
  'navigation.global-shortcuts.apps.assets': 'Активы',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Центр компании',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Цели',
  'navigation.global-shortcuts.apps.home': 'Главная',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Проекты',
  'navigation.global-shortcuts.apps.studio': 'Мастерская',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Команды',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Закрыть',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Сайт {name}',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(сейчас недоступно)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Значок перехода по внешней ссылке',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(загружается)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(загружается)',
  'navigation.global-shortcuts.sites': 'Сайты {productName}',
};
